import {
  STEPS,
  selectScheduleTourStep,
  setScheduleTourShowModal,
} from 'src/store/slices/scheduleTour'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'src/Components'
import ScheduleTourModalSteps from './Steps/ScheduleTourModalSteps'

import styles from './ScheduleTourModal.module.scss'

const ScheduleTourModal = () => {
  const dispatch = useDispatch()
  const currentStep = useSelector(selectScheduleTourStep)

  return (
    <Modal
      toggle={() => dispatch(setScheduleTourShowModal(false))}
      progress={((STEPS.indexOf(currentStep) + 1) / STEPS.length) * 100}
      progressColor='var(--brand-secondary-400)'
      className={styles.modal}
      overrideContent
      scrollOnWrapper
      resetScroll
      open
    >
      <ScheduleTourModalSteps />
    </Modal>
  )
}

export default ScheduleTourModal
